module.exports = __webpack_public_path__ + "img/Agencies-action.c6acc9ba.svg";